type Whitelabel = Readonly<{
  domain?: string;
  name: string;
  logo: string;
  accountContact: string;
}>;

const WHITELABELS = {
  apricot: {
    domain: 'client.apricotweb.co.uk',
    name: 'Apricot',
    logo: '/img/whitelabels/apricot_logo_white.png',
    accountContact: 'hello@apricotweb.co.uk',
  },
  // default
  m10c: {
    name: 'M10c',
    logo: '/img/logo_white.svg',
    accountContact: 'james@m10c.com',
  },
} as const;

export function getWhitelabel(): Whitelabel {
  const match = (Object.values(WHITELABELS) as Whitelabel[]).find(
    (x) => x.domain && x.domain === window.location.hostname
  );
  return match ?? WHITELABELS.m10c;
}
